export default __webpack_public_path__ + "static/multiple-channels-0678faba275842c36818233f5acf356c.png";